import { render, staticRenderFns } from "./sendTemplate.vue?vue&type=template&id=0b0f77ec&scoped=true&"
import script from "./sendTemplate.vue?vue&type=script&lang=js&"
export * from "./sendTemplate.vue?vue&type=script&lang=js&"
import style0 from "./sendTemplate.vue?vue&type=style&index=0&id=0b0f77ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f77ec",
  null
  
)

export default component.exports